module.exports = __webpack_public_path__ + "static/img/14.7705587.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/14.png
// module id = 9XxU
// module chunks = 0